import { ILink } from '../graphql/modules/link'
import { ILinksList } from '../graphql/modules/linksList'
import { filterHiddenInFrench } from './hideInFrench'

/**
 * @description on French pages, drops the header menu items and dropdown links marked "Hide on French pages".
 * A dropdown left without links is dropped too.
 */
export const filterNavbarHiddenInFrench = (
  navbar: Array<ILink | ILinksList> | null | undefined,
  isFrench: boolean,
): Array<ILink | ILinksList> => {
  if (!isFrench) return navbar ?? []
  return filterHiddenInFrench(navbar, isFrench)
    .map(item =>
      item.__typename === 'ContentfulLinksList' ? { ...item, links: filterHiddenInFrench(item.links, isFrench) } : item,
    )
    .filter(item => item.__typename !== 'ContentfulLinksList' || item.links.length > 0)
}
